export enum ExpandState {
    None,
    Overlay,
    Expanded
}
